module.exports = __webpack_public_path__ + "img/grey_star.ea4c2351.svg";